export default "__VITE_ASSET__34f790c2__"